import { InputForm } from '../CommonFormComponents';
import { withNumbers } from '../../hocs/withNumbers';
import { TEL_NUMBER_KEY } from '../../utilities/TelStore';

/**
 * InputFormを拡張、onUpdateをフックして電話番号の複数inputを管理
 */
export const TelInput = withNumbers(() => {
  return { keys: TEL_NUMBER_KEY };
})(InputForm);



// WEBPACK FOOTER //
// ./src/components/forms/TelInput.jsx